module.exports = __webpack_public_path__ + "img/top1_icon.43844573.svg";